import type { AreaKind } from '../domain/areaCatalog';
import type { IconName } from './icons';

// Icon tile per area kind (reference 01 row cards): one glyph per kind from the bundled
// Material Symbols Outlined 400 subset (src/ui/icons.ts).
export const AREA_KIND_ICONS: Record<AreaKind, IconName> = Object.freeze({
  exterior: 'yard',
  roof: 'roofing',
  garage: 'garage',
  basement: 'foundation',
  structure: 'construction',
  electrical: 'bolt',
  plumbing: 'plumbing',
  waterHeater: 'water_heater',
  hvac: 'hvac',
  attic: 'layers',
  interior: 'chair',
  kitchen: 'kitchen',
  bathroom: 'bathtub',
  bedroom: 'bed',
  safety: 'health_and_safety',
  other: 'category'
});
